<template>
  <div id="home" class="content">
    <div>
     <reiwa />に関するポータルサイト
    </div>
    <div class="icon">
      <font-awesome-icon icon="info-circle" size="1x"></font-awesome-icon>
      新元号.jp
    </div>
    <p><span v-if="profile.user">ようこそ {{profile.user.displayName}}さん！</span>
    </p>
  </div>
</template>

<script>
export default {
  data: function() {
      return {
        profile: this.$profile
      }
    },
  name: 'home',
  components: {
    
  }
}
</script>

<style>
  #home.content {
    background-color:#fefefe;
    height: 400px;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .icon {
  color: red;
  text-align: center;
  font-size: 4em;
}
</style>

